import {BASE_COUNTRY_URL, REQUEST_OPTIONS} from 'packages/constants/constants';
import {useCallback, useEffect, useState} from 'react';

// type useFetchResponse = {
//   data: any,
// }

type UseFetchParams = {
  apiUrl?: string;
  options?: RequestInit;
  skip?: boolean;
};

/**
 * @param apiUrl apiURL a la que vas enviar
 * @param options opciones del request
 * @param skip si quieres evitar mandar la petición al inicio
 * @returns la data, el indicador  de loading, una función para ejecutar el fetch manualmente y un arrreglo de errores
 */
const useFetch = ({
  apiUrl = BASE_COUNTRY_URL,
  options = REQUEST_OPTIONS,
  skip = false,
}: UseFetchParams) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(
    async (url, reqOptions, abortController = new AbortController()) => {
      setLoading(true);
      let jsonData = null;
      try {
        const response = await fetch(url, {
          ...reqOptions,
          signal: abortController.signal,
        });
        jsonData = await response.json();
        setData(jsonData);
      } catch (ex: any) {
        if (ex.name === 'AbortError') {
          return null;
        }
        setError(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
      return jsonData;
    },
    [error]
  );

  useEffect(() => {
    const abortController = new AbortController();
    if (!skip) {
      fetchData(apiUrl, options, abortController);
    }
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const get = useCallback(
    async (path: string) => {
      const abortController = new AbortController();
      const response = await fetchData(path, options, abortController);
      return response;
    },
    [fetchData, options]
  );

  return {data, loading, error, get};
};

export default useFetch;
// export function useFetch(request: RequestInfo, init?: RequestInit) {
//   const [response, setResponse] = useState<null | Response>(null);
//   const [error, setError] = useState<Error | null>();
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const abortController = new AbortController();
//     setIsLoading(true);
//     (async () => {
//       try {
//         const response = await fetch(request, {
//           ...init,
//           signal: abortController.signal,
//         });
//         setResponse(await response?.json());
//         setIsLoading(false);
//       } catch (error) {
//         if (error.name === "AbortError") {
//           return;
//         }
//         setError(error);
//         setIsLoading(false);
//       }
//     })();
//     return () => {
//       abortController.abort();
//     };
//   }, [init, request]);

//   return { response, error, isLoading };
// }

// export default useFetch;
